// @ts-check

import { get, getAll, getById } from "../utilities/querySelector";

jQuery(".burgerBun").on("click", function () {
    jQuery(".burgerBun").toggleClass("open");
    jQuery(".menu-mobile-menu-container").toggleClass("open");
});

jQuery(".menu-mobile-menu-container a").on("click", function () {
    jQuery(".burgerBun").removeClass("open");
    jQuery(".menu-mobile-menu-container").removeClass("open");
});

const header = getById("site-header");
const globalBanner = get(".site-header .global-banner");
const firstBlock = header.nextElementSibling; //next("section");

setHeaderScrollState();
window.addEventListener("scroll", setHeaderScrollState, { passive: true });
window.addEventListener("resize", setHeaderScrollState, { passive: true });

function setHeaderScrollState() {
    // if (!firstElement) {
    if (window.scrollY > 5) {
        header.classList.add("scroll");
    } else {
        header.classList.remove("scroll");
    }
    // } else {
    //     if (window.scrollY > firstElement.offsetHeight) {
    //         header.classList.add("scroll");
    //     } else {
    //         header.classList.remove("scroll");
    //     }
    // }
}

// headerPadding();

if (globalBanner) {
    headerPadding();
    window.addEventListener("resize", headerPadding, { passive: true });

    function headerPadding() {
        const body = document.body;
        let headerHeight = globalBanner.offsetHeight;
        let position = window.getComputedStyle(header).getPropertyValue("position");

        if (position == "fixed") {
            body.style.paddingTop = headerHeight + "px";
        }
    }
}
